import { render, staticRenderFns } from "./form-checkbox.vue?vue&type=template&id=6e422a4f&scoped=true"
import script from "./form-checkbox.vue?vue&type=script&lang=js"
export * from "./form-checkbox.vue?vue&type=script&lang=js"
import style0 from "./form-checkbox.vue?vue&type=style&index=0&id=6e422a4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e422a4f",
  null
  
)

export default component.exports